import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const postReview = async (reviewData) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.REVIEWS.POST_REVIEW, reviewData);
        return response; // Return the response data for the caller to handle
    } catch (error) {
        console.error("Error posting review:", error);
        throw error; // Re-throw the error for the caller to handle
    }
}

export const updateReview = async (reviewId, updatedData) => {
    try {
        const response = await apiClient.patch(`${API_ENDPOINTS.REVIEWS.UPDATE_REVIEW}${reviewId}/`, updatedData);
        return response.data;
    } catch (error) {
        console.error("Error updating review:", error);
        throw error;
    }
};

export const updateReviewVisibility = async (reviewId, visibilityValue) => {
    try {
        const response = await apiClient.patch(`${API_ENDPOINTS.REVIEWS.REVIEW_VISIBILITY}/${reviewId}/`, {
            visibility: visibilityValue,
        });
        return response.data;
    } catch (error) {
        console.error("Error updating review visibility:", error);
        throw error;
    }
};

export const deleteReview = async (reviewId) => {
    try {
        const response = await apiClient.delete(`${API_ENDPOINTS.REVIEWS.DELETE_REVIEW}${reviewId}/`);
        return response.data;
    } catch (error) {
        console.error("Error deleting review:", error);
        throw error;
    }
};

// Function to get reviews of user but preview
export const getUserReviews = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.REVIEWS.USER_REVIEWS_PREVIEW);
        return response; // Return the response data for the caller to handle
    } catch (error) {
        console.error("Error fetching user reviews:", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

// Function to get public reviews preview of a user by ID
export const getPublicUserReviews = async (userId) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.REVIEWS.PUBLIC_REVIEWS_PREVIEW}${userId}/`);
        return response.data; // Return the response data directly
    } catch (error) {
        console.error("Error fetching public user reviews:", error);
        throw error;
    }
};

// Function to get only visible reviews for the authenticated user
export const getAllUserReviews = async (params = {}) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.REVIEWS.USER_REVIEWS, { params });
        return response;
    } catch (error) {
        console.error("Error fetching user reviews:", error);
        throw error;
    }
};


export const getFreelancerReviews = async (freelancerId) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.REVIEWS.GET_FREELANCER_REVIEWS}/${freelancerId}/`);
        return response.data; // Return the data (reviews) for the caller to handle
    } catch (error) {
        console.error("Error fetching freelancer reviews:", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

export const getBusinessReviews = async (id) => {
    try {
        const response = await apiClient.get(`${API_ENDPOINTS.REVIEWS.GET_BUSINESS_REVIEWS}/${id}/`);
        return response.data; // Return the data (reviews) for the caller to handle
    } catch (error) {
        console.error("Error fetching freelancer reviews:", error);
        throw error; // Re-throw the error for the caller to handle
    }
};

export const getRatingSummary = async (providerType, providerId) => {
    try {
        const response = await apiClient.get(
            API_ENDPOINTS.REVIEWS.RATING_SUMMARY(providerType, providerId)
        );
        return response.data; // Return only data (same as updateReview)
    } catch (error) {
        console.error("Error fetching rating summary:", error);
        throw error; // Re-throw for caller to handle
    }
};